<div class="max-w-6xl mx-auto">
    <ng-content></ng-content>
</div>
